module.exports = __webpack_public_path__ + "static/media/product_640-1.a9a0ec64.jpg";